const elementIds = {
  navigation: {
    items: {
      logo: 'logo',
      languages: 'languages',
      notifications: 'notifications',
      burger: 'burger',
      profile: 'profile',
      dashboard: 'nav_dashboard',
      wallet: 'nav_wallet',
      ctp: 'nav_ctp',
      interconnect: 'nav_interconnect',
      buy: 'nav_buy',
      packages: 'nav_packages',
      profile2: 'nav_profile',
      apiSettings: 'nav_api_settings',
      logout: 'logout',
    },
    dropdownItems: {
      packages: {
        starPackages: 'nav_star_packages',
        metaverseLand: 'nav_metaverse_land',
        vimePurchase: 'nav_vime_purchase',
        vimeMbasePurchase: 'nav_vime_mbase_purchase',
        characterPurchase: 'nav_character_purchase',
        legacyProducts: 'nav_legacy_products',
      },
      buyItems: {
        creditCardLink: 'nav_credit_card_link',
        purchaseMinebase: 'nav_purchase_minebase',
        purchaseXon: 'nav_purchase_xon',
      },
      ctpItems: {
        mbaseToken: 'nav_ctp_mbase',
        xonToken: 'nav_ctp_xon',
      },
    },
  },
  dashboard: {
    availableBalance: {
      balanceLink: 'dash_balance_link',
      tokenConvertButton: id => `dash_convert_button_${id}`,
      asseLink: id => `dash_asset_link_${id}`,
      amountLink: id => `dash_amount_link_${id}`,
    },
    centerLinkBox: {
      myEarnings: 'dash_center_my_earnings',
      unilevelTree: 'dash_center_unilevel_tree',
      myDownline: 'dash_center_my_downline',
    },
    bottomLinkBox: {
      buyTokenVideo: 'dash_backoffice_buy_token_video',
      creditCardVideo: 'dash_backoffice_credit_card_video',
      starPackageVideo: 'dash_backoffice_star_package_video',
      buyToken: 'dash_backoffice_buy_token',
      creditCard: 'dash_backoffice_credit_card',
      staking: 'dash_backoffice_staking',
      starPackage: 'dash_backoffice_star_package',
      landingPage: 'dash_backoffice_landing_page',
      minebasePlatform: 'dash_backoffice_minebase_platform',
    },
  },
}

export default elementIds
